module.exports = __webpack_public_path__ + "img/6-4.3a933444.png";